import {cloneObject} from 'coreUtils/utils';

/**
 * Clones the CMS data and resolves multi-locale fields into a
 * single-locale representation, replicating the parseLocalized
 * step that the Traverser performed before traversal.
 *
 * Use this in place of `cmsProvider.getTraverser().traverse(data, {parseLocalized: true})`
 * when the traversal (visitor pipeline) is no longer needed.
 */
const localizeContent = (cmsProvider: any, data: any): any => {
	if (!data) {
		return null;
	}

	const clone = cloneObject(data);
	cmsProvider.parseLocalizedContent(clone);

	return clone;
};

export default localizeContent;
